import {forwardRef, Inject, Injectable} from '@angular/core';
import {SessionService} from './session.service';
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {UIConfiguration} from "../model/UIConfiguration";

import {DlgErrorMessage} from "../common/DlgErrorMessage";
import {DomSanitizer, SafeHtml, Title} from "@angular/platform-browser";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Utils} from "../model/Utils";

@Injectable()
export class UIService {

  private _uiConfiguration: UIConfiguration;

  constructor(private http: HttpClient,
              @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
              @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
              @Inject(forwardRef(() => Router)) private router: Router,
              @Inject(forwardRef(() => SessionService)) private session: SessionService,
              @Inject(forwardRef(() => Title)) private title: Title,
              @Inject(forwardRef(() => TranslateService)) private translate: TranslateService) {


    this.loadUIConfiguration().then((uiConfig)=>{
      this._uiConfiguration = uiConfig;
      if (this._uiConfiguration===null){
        console.log('UIService is NOT configured');
      }else{
        this.title.setTitle(this.pageTitleContent);
      }
    });

  }


  public get uiConfiguration(){
    return this._uiConfiguration;
  }


  loadUIConfiguration(): Promise<UIConfiguration> {
    return this.http.get('ui-configuration.json',{headers : this._getHeaders() }).toPromise().then(

      // response => console.log('response ' + response.json().server + ' response.text ' + response.text() )
      response => {
        //console.log('loadConfiguration ' + JSON.stringify(response.json()));
        return response as UIConfiguration;
      },
      rejected => { console.log('*** Cant load ui-configuration.json'); return null;}
    );
  }


  private _getHeaders():HttpHeaders{
    // 180 days in seconds
    const headers = new HttpHeaders({'Strict-Transport-Security': 'max-age: 15552000; includeSubDomains'});
    console.log('Using _getHeaders, ' + headers.get('Strict-Transport-Security'));
    return headers;
  }

  showContactUs(){
    if (Utils.isNullOrUndefined(this._uiConfiguration.contactUsButtonContent) || Utils.isNullOrUndefined(this._uiConfiguration.contactUsButtonLabel)){
      return;
    }


    const modalRef = this.modalService.open(DlgErrorMessage);
    const tmp: SafeHtml = this.domSanitizer.bypassSecurityTrustHtml(this.translate.instant(this._uiConfiguration.contactUsButtonContent));
    modalRef.componentInstance.populate(this.translate.instant(this._uiConfiguration.contactUsButtonLabel),null,'emprez-bleu',tmp);
    modalRef.result.then((result) => {
    });
    /*
    const modalRef = this.modalService.open(DlgUserPreferencesComponent, {size: 'lg'});
    this.alertService.registerModal(modalRef)
    modalRef.componentInstance.populate();
    // modalRef.componentInstance.populate(bean.data.employe.id, moment(bean.employeeHoraire.refDate));
    modalRef.result.then((result) => {
      console.log('Returning from User Preferences Component');
    }, (reason) => {
      // console.log(`Dismissed ${this.getDismissReason(reason)}`);
    });
    */

  }

  public get displayOtherLoginLogo(){
    if (this._uiConfiguration){
      if (!Utils.isNullOrUndefined(this._uiConfiguration.displayOtherLoginLogo)){
        return this._uiConfiguration.displayOtherLoginLogo;
      }
    }
    return false;
  }


  public get displayOtherDashboardLogo(){
    if (this._uiConfiguration){
      if (!Utils.isNullOrUndefined(this._uiConfiguration.displayOtherDashboardLogo)){
        return this._uiConfiguration.displayOtherDashboardLogo;
      }
    }
    return false;
  }

  public get pageTitleContent(){
    if (this._uiConfiguration){

        if (this._uiConfiguration.displayPageTitle===true){
          if (!Utils.isNullOrUndefined(this._uiConfiguration.pageTitleContent)){
            return this._uiConfiguration.pageTitleContent;
          }
        }

    }
    return 'Emprez';
  }


}


